var $16c606e9b72a71c3$exports = {};
$16c606e9b72a71c3$exports = {
    "backButton": (args)=>`Zur\xfcck zu ${args.prevMenuButton}`,
    "moreActions": `Mehr Aktionen`,
    "unavailable": `Nicht verf\xfcgbar, f\xfcr Details erweitern`
};


export {$16c606e9b72a71c3$exports as default};
//# sourceMappingURL=de-DE.module.js.map
